import React, { useState } from 'react'

import { Box, Typography, Button, Chip, Tooltip } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'
import PerfectScrollbar from 'react-perfect-scrollbar'

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'
import { MenuButton, Permitted } from 'components'
import { routes } from 'Routes'

import DialogChangeStatus from '../DialogChangeStatus'
import DialogDestroy from '../DialogDestroy'

import constants from 'constants/index'
import helpers from 'helpers'

import useStyles from '../../styles'

const TableRowCommittee = ({
  committee,
  setDialogOpen,
  setOpenDestroy,
  setCommittee,
  setActive,
  ...rest
}) => {
  const history = useHistory()
  const classes = useStyles()

  const handleRedirectShow = (committeeId) => {
    history.push(
      reverse(routes.committees.show, {
        committeeId,
      }),
    )
  }

  const handleOpenDialog = (active, committeeId) => {
    setActive(active)
    setCommittee(committeeId)
    setDialogOpen(true)
  }

  const handleDestroy = (committeeId) => {
    setCommittee(committeeId)
    setOpenDestroy(true)
  }

  return (
    <TableRow {...rest}>
      <TableCell>
        <Typography variant="body1">{committee?.id}</Typography>
      </TableCell>
      <TableCell>
        <Tooltip title={committee?.name || ''}>
          <Typography variant="body1" className={classes.truncatedText}>
            {committee?.name}
          </Typography>
        </Tooltip>
      </TableCell>
      <TableCell>
        <Typography variant="body1">{committee?.creator?.name}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body1">
          {helpers.formatters.date(committee?.createdAt)}
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Chip
          size="small"
          className={classes[committee?.status]}
          label={constants.committees.STATUSES[committee?.status]}
        />
      </TableCell>
      <TableCell align="right">
        <MenuButton>
          <Button
            color="secondary"
            onClick={() => handleRedirectShow(committee?.id)}
            fullWidth
            size="small"
          >
            Visualizar
          </Button>
          <Permitted tag={constants.permissions.COMMITTEES.MANAGE}>
            <Button
              color="secondary"
              onClick={() =>
                handleOpenDialog(
                  committee?.status === constants.committees.ACTIVE_STATUS,
                  committee?.id,
                )
              }
              fullWidth
              size="small"
            >
              {committee?.status === constants.committees.ACTIVE_STATUS
                ? constants.committees.INACTIVE_STATUS_LABEL
                : constants.committees.ACTIVE_STATUS_LABEL}
            </Button>
            <Button
              color="secondary"
              onClick={() => handleDestroy(committee?.id)}
              fullWidth
              size="small"
            >
              Excluir
            </Button>
          </Permitted>
        </MenuButton>
      </TableCell>
    </TableRow>
  )
}

const CommitteesTable = ({ committees, isLoading, onEvent }) => {
  const [committee, setCommittee] = useState()
  const [active, setActive] = useState()
  const [dialogChangeStatus, setDialogChangeStatus] = useState(false)
  const [dialogDestroy, setDialogDestroy] = useState(false)

  return (
    <Box width="100%">
      <PerfectScrollbar
        options={{ wheelPropagation: false, useBothWheelAxes: true }}
      >
        <Table
          size="small"
          emptyMessage="Nenhum comitê encontrado"
          isLoading={isLoading}
          noWrap
        >
          <TableHead>
            <TableRow>
              <TableCell width="10%">Identificador</TableCell>
              <TableCell width="30%">Nome do Comitê</TableCell>
              <TableCell width="20%">Criado por</TableCell>
              <TableCell width="20%">Data de Criação</TableCell>
              <TableCell width="10%" align="center">
                Status
              </TableCell>
              <TableCell width="20%" align="right">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {committees &&
              committees.map((committee) => (
                <TableRowCommittee
                  committee={committee}
                  key={committee.id}
                  setCommittee={setCommittee}
                  setActive={setActive}
                  setDialogOpen={setDialogChangeStatus}
                  setOpenDestroy={setDialogDestroy}
                  hover
                />
              ))}
          </TableBody>
        </Table>
      </PerfectScrollbar>
      {committees && (
        <>
          <DialogChangeStatus
            active={active}
            committeeId={committee}
            open={dialogChangeStatus}
            setOpen={setDialogChangeStatus}
            onEvent={onEvent}
          />
          <DialogDestroy
            committeeId={committee}
            open={dialogDestroy}
            setOpen={setDialogDestroy}
            onEvent={onEvent}
          />
        </>
      )}
    </Box>
  )
}

export default CommitteesTable
